module.exports = __webpack_public_path__ + "img/instagram-component.474a83a1.svg";